/**
 * ZOD VALIDATION SCHEMAS FOR AUTH
 *
 * WHY Zod? It validates data at RUNTIME (not just compile-time like TS interfaces).
 * If a user types "ab" for an email, Zod catches it before the API call fires.
 * The `z.infer<>` utility auto-generates the TypeScript type from the schema,
 * so you never have to define the same shape twice.
 */
import { z } from 'zod';
export const loginSchema = z.object({
    email: z
        .string()
        .min(1, 'Email wajib diisi') // Can't be empty
        .email('Format email tidak valid'), // Must be valid email
    password: z
        .string()
        .min(1, 'Password wajib diisi') // Can't be empty
        .min(6, 'Password minimal 6 karakter'), // Minimum length
});
//# sourceMappingURL=auth.schema.js.map